/*
 * @Author: zhanglei
 * @Date: 2023-12-19 16:25:01
 * @LastEditors: zhanglei
 * @LastEditTime: 2024-10-28 10:58:41
 * @Description: 艾瑞上报是2019年需求，当时市场部接了四个频道的上报（仅PC文章页 by 铿哥）
 */
//艾瑞上报参数中UA同频道ID的对应关系
var iwtUaMap = {
    //科技频道
    "30": "UA-sohuit-190003",
    //健康频道，按照科技频道上报
    "24": "UA-sohuit-190003",
    //动漫频道，按照科技频道上报
    "41": "UA-sohuit-190003",
    //游戏频道，按照科技频道上报
    "42": "UA-sohuit-190003",
}

/**
 * @description 设置艾瑞上报所需参数
 * @param { Object } conf 页面信息
 */
var setIwtReportParams = function (conf) {
    var irs_ua = iwtUaMap[conf.channel_id]
    //当作者为搜狐无人机时上报为科技频道
    if(conf.media_id == "204321") irs_ua = "UA-sohuit-190003"
    console.log('上报参数', irs_ua)
    if (!irs_ua) return
    window.irs_ua = irs_ua
    var ra = document.createElement('script')
    ra.type = 'text/javascript'
    ra.async = true
    ra.src = '//statics.itc.cn/iwtReport/iwt1.0.1.js' //iwt_1.0.1.js的URL位置，请客户自行托管JS文件，修改此值
    document.body.appendChild(ra)
}

export default setIwtReportParams